// extracted by mini-css-extract-plugin
export default {"spinnerBlock":"rwuRRSXSRF","commentsSectionContainer":"PzD4ZQAHX2","withMinHeight":"DRfD9NtiMf"};